import { Http } from "@/plugins/http.js";

export const getQrCodes = async patientId => {
  const { data } = await Http.get(`v1/customers/${patientId}/qr-codes`);
  if (Array.isArray(data)) {
    return data;
  }
  if (data?.data) {
    return data.data;
  }
  return [];
};
